import { FC, useEffect, useState } from 'react';
import { AxiosError } from 'axios';
import { Icon } from 'src/components/icon-generator';
import { IconType } from 'src/components/icon-generator/dto';
import { FMHLogoStripContainer } from '../fmh-logo-strip-container';
import Style from './ff-footer.module.scss';
import LanguageFunction from '@/utils/languageCode';
import { FFLinkList } from '@/atoms/ff-link-list';
import { FFDivider } from '@/atoms/ff/ff-divider';
import PageService from '@/services/page-service';
import { PageConfigurationType } from '@/types/apiDtos';
import { Logger } from '@/utils/logger';
import FooterProps from '@/organisms/ff-footer/dto';

const Footer: FC<FooterProps> = (props: FooterProps): JSX.Element => {
    const [pageConfigurationData, setPageConfigurationData] = useState<PageConfigurationType>();

    useEffect(() => {
        PageService.getPageConfiguration(LanguageFunction.getLocalStorageLocale(), props.pageRelativeUrl.slice(3))
            .then((configuration: PageConfigurationType) => {
                if (configuration) {
                    setPageConfigurationData(configuration);
                }
            })
            .catch((e: AxiosError) => {
                Logger.error(`An error occurred while displaying header/footer data${e}`);
            });
        return () => {
            setPageConfigurationData(undefined); // This worked for me
        };
    }, [props.pageRelativeUrl]);

    return pageConfigurationData?.defaultFooter ? (
        <footer className={Style.footer}>
            <FFDivider />
            <div className="ff-bg-white">
                <FMHLogoStripContainer logoStrips={pageConfigurationData.defaultFooter.logoStrips} />
            </div>
            <FFDivider />
            <div className={`d-flex align-items-center justify-content-center ${Style.footerContainer}`}>
                <div className={`row ff-px-8 ff-px-md-32 ff-py-16 ff-py-lg-8 container ${Style.bottomRow}`}>
                    <div className={`col-sm-4 col-lg-3 ff-mb-32 ff-mb-sm-0 d-flex align-self-center`}>
                        <Icon icon={IconType.FMHLogo} className={Style.logo} />
                    </div>
                    <div className={`col-sm-6 col-lg-6 d-flex align-self-center`}>
                        <div className={`row`}>
                            <div className={`d-none d-md-flex ff-mb-md-8 col-12 align-self-center`}>
                                <FFLinkList
                                    links={pageConfigurationData.defaultFooter.bottomLinks.links}
                                    isHorizontal={true}
                                />
                            </div>
                            <div className={`d-flex d-md-none col-12 align-self-center`}>
                                <FFLinkList
                                    links={pageConfigurationData.defaultFooter.bottomLinks.links}
                                    isHorizontal={false}
                                />
                            </div>
                            <div className={`col-12 d-flex align-self-center`}>
                                {pageConfigurationData.defaultFooter.bottomLinks ? (
                                    <p className="ff-mt-16 ff-mt-sm-0 ff-mb-0">
                                        <b className={`overline ${Style.copyrightLine}`}>
                                            {pageConfigurationData.defaultFooter.bottomLinks.title}
                                        </b>
                                    </p>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    ) : (
        <></>
    );
};

export default Footer;
